export default __webpack_public_path__ + "static/media/orange-map-dot-viewed.4c0e0328.svg";